import React from 'react';
import { require } from 'js/backbone/portlets';
import { componentService } from 'js/services/component.service';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';
import { withPortlet, usePortletConfig } from 'js/components/system/Portlet';

import { MOBILE_CASHIER } from './constants';

class MobileCashierWrapper extends React.Component {
    componentDidMount() {
        require(['portlets_cashier_cashier_model'], (Model) => {
            const model = new Model({ config: this.props.config, ...this.props.config }, { parse: true });

            this.view = model.getView();
            this.view.detachWidget(this.view.$el, 'accordion');
            this.view.setElement(this.el).render();
            this.view.attachWidget(this.view.$el.accordion());
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.config.cashierType !== prevProps.config.cashierType) {
            require(['portlets_cashier_cashier_model'], (Model) => {
                const model = new Model({ config: this.props.config, ...this.props.config }, { parse: true });

                this.view = model.getView();
                this.view.detachWidget(this.view.$el, 'accordion');
                this.view.setElement(this.el).render();
                this.view.attachWidget(this.view.$el.accordion());
            });
        }
    }

    componentWillUnmount() {
        this.view && this.view.close();
    }

    render() {
        return <BackboneWrapper el={el => this.el = el} />;
    }
}

const MobileCashierBare = () => {
    const config = usePortletConfig();

    return <MobileCashierWrapper config={config} />;
};

export const MobileCashier = withPortlet()(MobileCashierBare);

componentService.registerPageComponents({ [MOBILE_CASHIER]: MobileCashier });
